const recruit = document.getElementById('recruit')

{
  document.addEventListener('DOMContentLoaded', function() {
    if (recruit) {
      const bottom = document.querySelector('.js-target');
      const stalker = document.querySelector('.stalker');

      bottom.addEventListener('mouseenter', function() {
        stalker.classList.add('-show');
      });

      bottom.addEventListener('mouseleave', function() {
        stalker.classList.remove('-show');
      });

      document.addEventListener('mousemove', function(event) {
          if (stalker.classList.contains('-show')) {
            const relativeX = event.clientX;
            const relativeY = event.clientY;

            stalker.style.transform = 'translate(' + relativeX + 'px, ' + relativeY + 'px)';
          }
      });
    }
  });

}
